import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import { FifoEnum, OnHandReportFifoEnum } from 'Common/FieldEnum';
import {
  DATE_FORMAT_FOR_SERVER,
  DATE_FORMAT_FOR_UI,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { ON_HAND_REPORT_FIFO_FORM_NAME } from 'Common/FormEnum';
import { ToolTipComponent } from 'Components';
import { PACK_SIZE_MESSAGE } from 'Common/Constants/inventory';
import { PrintGroupByTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';

import FIFOReportComponent from '../../components/FIFOReport';
import {
  getOnHandFIFOItems,
  setFromDateMax,
  setToDateMin,
} from '../../state/actions';
import { INITIAL_VALUES } from '../../helper/fifo';
import * as OnHandReportSelectors from '../../state/selectors';

class FIFOReport extends Component {
  static propTypes = {
    getOnHandFIFOItems: PropTypes.func.isRequired,
    setFromDateMax: PropTypes.func.isRequired,
    setToDateMin: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    onHandFifoItems: PropTypes.array.isRequired,
    onSubmit: PropTypes.func,
    handleClickPrint: PropTypes.func,
    printOptionsValue: PropTypes.number,
    FromDt: PropTypes.string,
    ToDt: PropTypes.string,
    disableFromToDates: PropTypes.bool,
    gridPreferenceLoading: PropTypes.bool,
    gridPreferenceSubmitting: PropTypes.bool,
    loadingOnHandFifoItems: PropTypes.bool,
    selectedFifoSitesItems: PropTypes.object,
    fromDateMax: PropTypes.object,
    toDateMin: PropTypes.object,
  };

  static defaultProps = {
    onSubmit: () => {},
    handleClickPrint: () => {},
    printOptionsValue: PrintGroupByTypeEnum.Item,
    FromDt: '',
    ToDt: '',
    disableFromToDates: false,
    gridPreferenceLoading: false,
    gridPreferenceSubmitting: false,
    loadingOnHandFifoItems: false,
    selectedFifoSitesItems: null,
    fromDateMax: null,
    toDateMin: null,
  };

  state = {
    activeIndexes: [0, 1],
    columns: [
      {
        Header: 'Item Code',
        accessor: FifoEnum.ItemCode,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Description',
        accessor: FifoEnum.Description,
        width: 200,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Site Id',
        accessor: FifoEnum.SiteId,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Receipt Date',
        accessor: FifoEnum.ReceiptDT,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Qty',
        accessor: FifoEnum.PrimaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Unit',
        accessor: FifoEnum.Unit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Qty',
        accessor: FifoEnum.SecondaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Unit',
        accessor: FifoEnum.SecondaryUnit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: () => {
          return (
            <ToolTipComponent
              label={'Pack Size'}
              popMessage={PACK_SIZE_MESSAGE}
              iconName="question circle outline"
            />
          );
        },
        visibilityName: 'Pack Size',
        accessor: FifoEnum.QtyPerUnit,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Price',
        accessor: FifoEnum.Price,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'On Hand Value',
        accessor: FifoEnum.Value,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        resizable: false,
        width: 50,
        sortable: false,
        filterable: false,
      },
    ],
  };

  clearFilters = () => {
    const { selectedFifoSitesItems, change } = this.props;
    change(OnHandReportFifoEnum.ShowAllDates, true);
    change(
      OnHandReportFifoEnum.FromDt,
      INITIAL_VALUES[OnHandReportFifoEnum.FromDt]
    );
    change(
      OnHandReportFifoEnum.ToDt,
      INITIAL_VALUES[OnHandReportFifoEnum.ToDt]
    );
    this.props.getOnHandFIFOItems({
      ...selectedFifoSitesItems,
      FromDt: INITIAL_VALUES[OnHandReportFifoEnum.FromDt],
      ToDt: INITIAL_VALUES[OnHandReportFifoEnum.ToDt],
      ShowAllDates: INITIAL_VALUES[OnHandReportFifoEnum.ShowAllDates],
    });
  };

  onChangeOfFromDT = (e, newValue, prevDate) => {
    const { ToDt, disableFromToDates } = this.props;
    this.props.setToDateMin(moment(newValue, DATE_FORMAT_FOR_UI));
    newValue !== prevDate &&
      this.getFifoItems(newValue, ToDt, disableFromToDates);
  };

  onChangeOfToDT = (e, newValue, prevDate) => {
    const { FromDt, disableFromToDates } = this.props;
    this.props.setFromDateMax(moment(newValue, DATE_FORMAT_FOR_UI));
    newValue !== prevDate &&
      this.getFifoItems(FromDt, newValue, disableFromToDates);
  };

  getFifoItems = (fromDt, toDt, showAllOption) => {
    const { selectedFifoSitesItems } = this.props;
    this.props.getOnHandFIFOItems({
      ...selectedFifoSitesItems,
      FromDt: moment(fromDt).format(DATE_FORMAT_FOR_SERVER),
      ToDt: moment(toDt).format(DATE_FORMAT_FOR_SERVER),
      ShowAllDates: showAllOption,
    });
  };

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  onChangeOfShowAllOption = (e, newValue) => {
    const { FromDt, ToDt } = this.props;
    this.getFifoItems(FromDt, ToDt, newValue);
  };

  render() {
    const {
      onHandFifoItems,
      loadingOnHandFifoItems,
      handleClickPrint,
      printOptionsValue,
      disableFromToDates,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fromDateMax,
      toDateMin,
    } = this.props;
    return (
      <FIFOReportComponent
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        activeIndexes={this.state.activeIndexes}
        clearFilters={this.clearFilters}
        columns={this.state.columns}
        onChangeOfToDT={this.onChangeOfToDT}
        onChangeOfFromDT={this.onChangeOfFromDT}
        setPrintOption={this.setPrintOption}
        loadingOnHandFifoItems={loadingOnHandFifoItems}
        onHandFifoItems={onHandFifoItems}
        handleClickPrint={handleClickPrint}
        printOptionsValue={printOptionsValue}
        disableFromToDates={disableFromToDates}
        gridPreferenceLoading={gridPreferenceLoading}
        gridPreferenceSubmitting={gridPreferenceSubmitting}
        onChangeOfShowAllOption={this.onChangeOfShowAllOption}
        fromDateMax={fromDateMax}
        toDateMin={toDateMin}
      />
    );
  }
}

FIFOReport = reduxForm({
  form: ON_HAND_REPORT_FIFO_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(FIFOReport);

const selector = formValueSelector(ON_HAND_REPORT_FIFO_FORM_NAME);
const mapStateToProps = state => {
  return {
    printOptionsValue: selector(state, [OnHandReportFifoEnum.PrintOptions]),
    FromDt: selector(state, OnHandReportFifoEnum.FromDt),
    ToDt: selector(state, OnHandReportFifoEnum.ToDt),
    disableFromToDates: selector(state, OnHandReportFifoEnum.ShowAllDates),
    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),
    onHandFifoItems: OnHandReportSelectors.getOnHandFifoItems(state),
    loadingOnHandFifoItems: OnHandReportSelectors.getLoadingOnHandFifoItems(
      state
    ),
    selectedFifoSitesItems: OnHandReportSelectors.getSelectedFifoSitesItems(
      state
    ),
    fromDateMax: OnHandReportSelectors.getFromDateMax(state),
    toDateMin: OnHandReportSelectors.getToDateMin(state),
  };
};

const mapDispatchToProps = {
  getOnHandFIFOItems,
  setFromDateMax,
  setToDateMin,
};

export const FIFOReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FIFOReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/fiforeport/FIFOReport.js